!(function () {
  "use strict";
  var e,
    n = {
      1520: function (e, n, r) {
        r(3945);
        var t = r(2223),
          o = r(2817),
          i = r.n(o),
          u = document.querySelectorAll(".product-images");
        u &&
          u.forEach(function (e, n) {
            var r = e.querySelector(".swiper"),
              o = e.querySelector(".product-image-count"),
              i = new t.Z(r, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: !0,
                on: {
                  slideChange: function (e) {
                    if (o.hasAttribute("data-announce")) {
                      o.textContent = "Image " + (e.realIndex + 1) + " of " + o.dataset.total;
                    } else {
                      o.querySelector("span").textContent = e.realIndex + 1;
                    }
                  },
                },
              });
            var nextBtn = e.querySelector(".product-images-next");
            nextBtn.addEventListener("click", function () {
              i.slideNext();
            });
            if (o.hasAttribute("data-announce")) {
              nextBtn.addEventListener("focus", function () {
                o.removeAttribute("aria-hidden");
              });
              nextBtn.addEventListener("blur", function () {
                o.setAttribute("aria-hidden", "true");
              });
            }
            if (e.hasAttribute("data-no-aria-live")) {
              var w = r.querySelector(".swiper-wrapper");
              if (w) w.removeAttribute("aria-live");
            }
            if (e.hasAttribute("data-hide-inactive")) {
              var s = function () {
                r.querySelectorAll(".swiper-slide").forEach(function (slide) {
                  var active = slide.classList.contains("swiper-slide-active");
                  slide.setAttribute("aria-hidden", String(!active));
                  if (active) slide.removeAttribute("inert");
                  else slide.setAttribute("inert", "");
                });
              };
              s();
              i.on("slideChangeTransitionEnd", s);
            }
          }),
          new (i())(".product-images", {
            /*stickTo: ".main-product",
            top: 120,
            responsive: { 768: { disable: !0 } },*/
          });
      },
    },
    r = {};
  function t(e) {
    var o = r[e];
    if (void 0 !== o) return o.exports;
    var i = (r[e] = { id: e, loaded: !1, exports: {} });
    return n[e].call(i.exports, i, i.exports, t), (i.loaded = !0), i.exports;
  }
  (t.m = n),
    (e = []),
    (t.O = function (n, r, o, i) {
      if (!r) {
        var u = 1 / 0;
        for (l = 0; l < e.length; l++) {
          (r = e[l][0]), (o = e[l][1]), (i = e[l][2]);
          for (var c = !0, a = 0; a < r.length; a++)
            (!1 & i || u >= i) &&
            Object.keys(t.O).every(function (e) {
              return t.O[e](r[a]);
            })
              ? r.splice(a--, 1)
              : ((c = !1), i < u && (u = i));
          if (c) {
            e.splice(l--, 1);
            var f = o();
            void 0 !== f && (n = f);
          }
        }
        return n;
      }
      i = i || 0;
      for (var l = e.length; l > 0 && e[l - 1][2] > i; l--) e[l] = e[l - 1];
      e[l] = [r, o, i];
    }),
    (t.n = function (e) {
      var n =
        e && e.__esModule
          ? function () {
              return e.default;
            }
          : function () {
              return e;
            };
      return t.d(n, { a: n }), n;
    }),
    (t.d = function (e, n) {
      for (var r in n)
        t.o(n, r) &&
          !t.o(e, r) &&
          Object.defineProperty(e, r, { enumerable: !0, get: n[r] });
    }),
    (t.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    })()),
    (t.o = function (e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }),
    (t.nmd = function (e) {
      return (e.paths = []), e.children || (e.children = []), e;
    }),
    (t.j = 137),
    (function () {
      var e = { 137: 0 };
      t.O.j = function (n) {
        return 0 === e[n];
      };
      var n = function (n, r) {
          var o,
            i,
            u = r[0],
            c = r[1],
            a = r[2],
            f = 0;
          if (
            u.some(function (n) {
              return 0 !== e[n];
            })
          ) {
            for (o in c) t.o(c, o) && (t.m[o] = c[o]);
            if (a) var l = a(t);
          }
          for (n && n(r); f < u.length; f++)
            (i = u[f]), t.o(e, i) && e[i] && e[i][0](), (e[i] = 0);
          return t.O(l);
        },
        r = (self.webpackChunkworkflow = self.webpackChunkworkflow || []);
      r.forEach(n.bind(null, 0)), (r.push = n.bind(null, r.push.bind(r)));
    })();
  var o = t.O(void 0, [216], function () {
    return t(1520);
  });
  o = t.O(o);
})();
